import API from './../api'
let token = localStorage.getItem("token");

export const getEmployeeMappingDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const getEmployeeMappingRolesDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const getEmployeeMappingAccountsDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const getEmployeeMappingSitesDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
      }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const updateUsermembershipDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const updateUsermembershipDeleteService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };